export const routeKeys = {
  wissenswertes: '/wissenswertes',
  alltagsHelfer: '/alltagshelfer',
  ausbildungsnachweise: '/ausbildungsnachweise',
  alteAusbildungsnachweise: '/ausbildungsnachweise/alteAusbildungsnachweise',
  newAusbildungsnachweisWithNummer: '/ausbildungsnachweise/neu/:nummer',
  ausbildungsnachweisePerUser: '/ausbildungsnachweise/user/:azubiId',
  ausbildungsnachweisDetail: '/ausbildungsnachweise/:id',
  ausbildungsplan: '/ausbildungsplan',
  ausbildungsplanForUser: '/ausbildungsplan/:azubiId',
  ausbildungsplanChapterStatic: '/ausbildungsplan/:azubiId/static/:chapterId',
  ausbildungsplanChapterQuestions: '/ausbildungsplan/:azubiId/questions/:chapterId',
  praxisaufgabenOverview: '/praxisaufgabenOverview',
  praxisaufgabenDetail: '/praxisaufgabenOverview/:azubiId',
  wissensportal: '/wissensportal',
  next: '/next',
  wissensportalPerUser: '/wissensportal/user/:azubiId',
  nextPerUser: '/next/user/:azubiId',
  meineazubisForAusbilder: '/meineorganisation/meineazubis',
  meineausbilder: '/meineorganisation/meineausbilder',
  meineazubis: '/meineazubis',
  meineausbildung: '/meineausbildung',
  login: '/login',
  versetzungsplan: '/versetzungsplan',
  ablaufundtermine: '/ablaufundtermine',
  benachrichtigungen: '/benachrichtigungen',
  licenses: '/lizenzen',
  licensesMobile: '/lizenzen-mobile',
  uebersicht: '/uebersicht',
  uebersichtAusbildungsnachweise: '/uebersicht/ausbildungsnachweise',
  uebersichtAusbildungsplan: '/uebersicht/ausbildungsplan',
  uebersichtPraxisaufgaben: '/uebersicht/praxisaufgaben',
  ressourcenplanung: '/ressourcenplanung',
  chat: '/chat',
  feedback: '/feedback',
}

export const routeHelper = {
  ausbildungsnachweisDetail: id => routeKeys.ausbildungsnachweisDetail.replace(':id', id),
  ausbildungsnachweisePerUser: azubiId => routeKeys.ausbildungsnachweisePerUser.replace(':azubiId', azubiId),
  nextPerUser: azubiId => routeKeys.nextPerUser.replace(':azubiId', azubiId),
  ausbildungsplanForUser: azubiId => routeKeys.ausbildungsplanForUser.replace(':azubiId', azubiId),
  ausbildungsplanStaticChapter: (azubiId, chapterId) =>
    routeKeys.ausbildungsplanChapterStatic.replace(':azubiId', azubiId).replace(':chapterId', chapterId),
  ausbildungsplanQuestionsChapter: (azubiId, chapterId) =>
    routeKeys.ausbildungsplanChapterQuestions.replace(':azubiId', azubiId).replace(':chapterId', chapterId),
  praxisaufgabenDetail: azubiId => routeKeys.praxisaufgabenDetail.replace(':azubiId', azubiId),
  uebersichtAusbildungsnachweise: () => routeKeys.uebersichtAusbildungsnachweise,
  newAusbildungsnachweisWithNummer: nummer => routeKeys.newAusbildungsnachweisWithNummer.replace(':nummer', nummer),
}

export const legacyRoutes = [
  {
    legacy: routeKeys.wissensportalPerUser,
    redirect: routeKeys.nextPerUser,
  },
  {
    legacy: routeKeys.wissensportal,
    redirect: routeKeys.next,
  },
  {
    legacy: routeKeys.versetzungsplan,
    redirect: routeKeys.ablaufundtermine,
  },
]
